import { CustomersApi } from 'src/orchd-client';

import { axiosInstance } from 'src/utils/axios';

export const customersApi = CustomersApi({}, '/api', axiosInstance);
